import React from 'react';
import styled from 'styled-components';
import { ErrorMessage, FormikProps } from 'formik';

import { Switcher } from '@shared/fields';
import { AdaptivePicture } from '@shared/AdaptivePicture';
import { FORM_TEXTS } from '../../formDictionary';
import { LabeledField } from '../../../../LabeledField';
import stores from '../../../../../stores';
import { DrivingSchoolsType } from '../../constants';
import banner from '../../../../../images/examCentersReviewMobileBanner/banner-100@2x.webp';
import banner2x from '../../../../../images/examCentersReviewMobileBanner/banner-100@3x.webp';
import { LegalField } from '../LegalField';
import { ReviewFormValues } from '../../types';
import { ErrorMessageContainer } from '../../../../fields/common/ErrorMessageContainer';

const SwitcherWrap = styled.div`
  input:checked + label {
    ${({ theme }) => `
      background-color: ${theme.drivingSchoolTypeColor} !important;
      color: ${theme.drivingSchoolSelectedTypeFontColor} !important;
    `}
  }
  
  label {
    padding: 0 8px;
    white-space: nowrap;
    height: 48px;
    line-height: 48px;
  }
`;

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px -8px;
`;

const bannerStyles = {
  width: '100%',
  maxWidth: '480px',
};

type StudyTypeStepProps = FormikProps<ReviewFormValues>;

const StudyTypeStep = ({
  values, errors, touched, handleChange,
}: StudyTypeStepProps) => {
  const { drivingSchoolType, helpSearchSchool } = FORM_TEXTS;
  return (
    <>
      <LabeledField label={drivingSchoolType.label} error={errors.drivingSchoolType && touched.drivingSchoolType} isFullWidthLabel>
        <SwitcherWrap>
          <Switcher
            items={drivingSchoolType.items}
            name="drivingSchoolType"
            activeItem={values.drivingSchoolType}
            onChange={(e) => {
              stores.examCenterReviewStore.setSchoolType(e.target.value);
              handleChange(e);
            }}
          />
        </SwitcherWrap>
        <ErrorMessage component={ErrorMessageContainer} name="drivingSchoolType" />
      </LabeledField>

      {(values.drivingSchoolType === DrivingSchoolsType.ONLINE || values.drivingSchoolType === DrivingSchoolsType.NONE) && (
        <>
          <LabeledField label={helpSearchSchool.label} isFullWidthLabel>
            <SwitcherWrap>
              <Switcher
                items={helpSearchSchool.items}
                name="helpSearchSchool"
                activeItem={values.helpSearchSchool}
                onChange={handleChange}
              />
            </SwitcherWrap>
          </LabeledField>
          <BannerWrapper>
            <AdaptivePicture
              srcset={[
                { src: banner },
                { src: banner2x, size: '2x' },
              ]}
              img={banner}
              alt=""
              styles={bannerStyles}
            />
          </BannerWrapper>
        </>
      )}

      {
        (values.drivingSchoolType === DrivingSchoolsType.TRADITIONAL || values.helpSearchSchool === '0') && (
          <LegalField errors={errors} touched={touched} values={values} handleChange={handleChange} />
        )
      }
    </>
  );
};

export { StudyTypeStep };
